// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsScopes = {
  scopesTitle: "作用域",
  scopes: {
    mine: "我的",
    shared_with_me: "共享给我的",
    public: "公共",
    all: "全部",
  },
} as const;
